import React from 'react';
import ConnectedLogin from '../containers/Login';

function Home(props) {
  return (
      <div className="Home">
        <ConnectedLogin history={props.history} />
      </div>
  );
}

export default Home;


// WEBPACK FOOTER //
// ./src/components/Home.js